/**
 * Mutation pour l'import de sorties via Excel (NOUVEAU).
 * Invalide les caches pour forcer le rafraîchissement.
 */
import { ApiMananger } from "actions/rtkquery";
import { INVALIDATE_FOURNISSEURS, INVALIDATE_PRODUITS, INVALIDATE_DEPENSES } from "../invalidationTags";

const importSortieApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    importSortiesExcel: build.mutation({
      query: (formData) => ({
        url: "v1/sorties/import-excel/",
        method: "POST",
        body: formData,
      }),
      // Invalider les caches pour forcer le rafraîchissement (NOUVEAU)
      invalidatesTags: [
        INVALIDATE_DEPENSES,
        INVALIDATE_PRODUITS,
        INVALIDATE_FOURNISSEURS,
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useImportSortiesExcelMutation } = importSortieApi;
